import { isDevMode } from '@angular/core';
import { ActionReducerMap, MetaReducer } from '@ngrx/store';

export interface IState {}
export const reducers: ActionReducerMap<IState> = {};
export const metaReducers: MetaReducer<IState>[] = isDevMode() ? [] : [];
